import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import ErrorBoundary, { isChunkLoadError, reloadForNewVersion } from "@/components/ErrorBoundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// A stale bundle after a deploy should silently reload instead of leaving a blank page.
window.addEventListener("error", (e) => { if (String(e?.filename || "").includes("/static/js/") && isChunkLoadError(e?.error || e?.message)) reloadForNewVersion(); });
window.addEventListener("unhandledrejection", (e) => { if (isChunkLoadError(e?.reason)) reloadForNewVersion(); });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
